import styled from "styled-components";

export const MusicHallAndPracticeThankContainerStyled = styled.div`
  padding: 20px 20px 46px 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .music_hall_and_practice_thank_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .thank_label {
      margin-top: 120px;
      margin-bottom: 140px;
      padding: 0 114px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.Sๅุ};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      white-space: pre-wrap;
    }
    .btn_back_layout {
      margin: auto;
      max-width: 294px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 46px 20px;
    .breadcrumb_layout {
      display: none;
    }
    .music_hall_and_practice_thank_container {
      .thank_label {
        margin-top: 50px;
        margin-bottom: 150px;
        padding: 0 11.5px;
      }
      .btn_back_layout {
        max-width: 294px;
      }
    }
  }
`;
